import { matchesMentionQuery } from './matchesMentionQuery.js'
import { MAX_PER_SECTION } from './mentionConstants.js'

export function filterAndCap(items, query) {
  return items
    .filter((item) => matchesMentionQuery(query, item._keys))
    .slice(0, MAX_PER_SECTION)
    .map(({ _keys, ...rest }) => rest)
}
